// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1GI-E","selects":"Documents_selects__1a-Mh"};